import React from 'react';
import { useEffect, useState } from 'react';
import { Box } from '@mui/material';


const PasswordStrengthMeter = ({ password, setIsStrongPassword }: {
  password: string,
  setIsStrongPassword?: (value: (((prevState: boolean) => boolean) | boolean)) => void
}) => {
  const [strength, setStrength] = useState(0);

  useEffect(() => {
    setStrength(calculateStrength(password));
  }, [password]);

  const calculateStrength = (password: string) => {
    let score = 0;

    if (password.length >= 8) score += 1;
    if (/[A-Z]/.test(password) && /[a-z]/.test(password)) score += 1;
    if (/[0-9]/.test(password)) score += 1;
    if (/[@$!%*?&]/.test(password)) score += 1;

    if (setIsStrongPassword) {
      setIsStrongPassword(score == 4);
    }

    return score;
  };

  return (
    <Box sx={{ width: '100%' }}>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          marginTop: '3px',
        }}
      >
        {[...Array(4)].map((_, index) => (
          <Box
            key={index}
            sx={{
              width: '24%',
              height: '6px',
              borderRadius: '5px',
              backgroundColor:
                index < strength
                  ? index < 2
                    ? '#FF0000' // Red
                    : index < 3
                      ? '#FFFF00' // Yellow
                      : '#00FF00' // Green
                  : 'rgba(231,231,234,0.8)',
              transition: 'background-color 0.3s',
            }}
          />
        ))}
      </Box>
    </Box>
  );
};

export default PasswordStrengthMeter;